import { Button, ButtonGroup, Callout, Intent, Popover} from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as configActions from "core/actions/configActions";

/**
 * @overview: Displays a list of unsaved edits and provides
 * options for saving or discarding them
 *
 * @author: jesposito
 */

export interface IApplyChangesProps {
	changes: number;
	actions?: any;
}

const ApplyChanges: React.SFC<IApplyChangesProps> = (props) => {

	if(props.changes > 0) {
		const cont = (
			<div style={{padding: "15px"}}>
				<Callout icon={IconNames.WARNING_SIGN} title={"Unsaved Changes"} intent={Intent.WARNING}>
					<b>{props.changes}</b> config modification{props.changes > 1 && "s"}
				</Callout>
				<br />
				<Button intent={Intent.PRIMARY} onClick={props.actions.saveConfig}>Save</Button>
				&nbsp;
				<Button intent={Intent.DANGER} minimal={true} onClick={props.actions.loadConfig}>Discard</Button>
			</div>
		);

		return (
			<Popover content={cont} usePortal={false}>
				<Button intent={Intent.SUCCESS}>{props.changes}</Button>
			</Popover>
		);
	}

	return null;
};

const mapStateToProps = (state): IApplyChangesProps => {
	return {
		changes: state.edit.changes
	};
};

const mapDispatchToProps = (dispatch) => {
	return { actions: bindActionCreators(configActions as any, dispatch) };
};

export default connect<IApplyChangesProps>(mapStateToProps, mapDispatchToProps)(ApplyChanges);



// WEBPACK FOOTER //
// ./src/core/components/editor/ApplyChanges.tsx